import { EXTERNAL_NAME } from '@meltwater/mi-manifest-client/build/external-name.js';


class ManifestClientServiceController {
    constructor() {}

    init() {
        const manifestClient: any = window[EXTERNAL_NAME] || window['miManifestClientV1'];
        
        if (!manifestClient) {
            throw new Error("Could not find Manifest Client");
        }

        let currentManifestEnvironment;
        const currentHostName = window.location.hostname;

        if (currentHostName.indexOf('.com') !== -1) {
            currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
        } else {
            currentManifestEnvironment = manifestClient.Environments.STAGING;
        }

        manifestClient.Initializer.initialize(currentManifestEnvironment);

        manifestClient.ManifestClient.getInstance().then(manifestClientInstance => {
            manifestClientInstance.getCurrentManifest();
        });
    }

    async getManifest() {
        const manifestClient: any = window[EXTERNAL_NAME || "miManifestClientV1"];
        let instance = await manifestClient.ManifestClient.getInstance()
        return await instance.getCurrentManifest();
    }

    async getCurrentUser() {
        const manifest = await this.getManifest();
        return manifest.user;
    }

    // Ask for treatment from the manifest service. If it is not included undefined should be returned.
    async getUserTreatment(treatment:string) {
      const manifest = await this.getManifest();
      return manifest.featureToggles.user.treatments[treatment];
    }

    async getNavigation() {
        const manifest = await this.getManifest();
        return {
            items: manifest.navigation,
            groups: manifest.navigationGroups
        }
    }
}

export const ManifestClientService = new ManifestClientServiceController();